import styled from "@emotion/styled";
import type { HTMLAttributes } from "react";

import { MediaIconContainer } from "@skilitics/designer-ui-components";

const width = 83;
const height = 63;

export const ThumbnailMenu = styled.div`
  position: absolute;
  top: -14px;
  right: -14px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 26px;
  height: 26px;

  background-color: ${({ theme }) => (theme.type === "light" ? theme.surfaceBack_1 : theme.surfaceBack_2)};
  color: ${({ theme }) => theme.generalTextIcon};

  opacity: 0;
  pointer-events: none;

  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.primarySelection};
  clip-path: border-box;

  transition: opacity 125ms ease-in-out;
`;

const StyledThumbnail = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  width: ${width}px;
  min-width: ${width}px;
  height: ${height}px;

  border: ${({ theme }) => `2px ${theme.outlineMedium} solid`};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.surfaceVariant};
  cursor: pointer;

  & div > svg {
    width: ${width - 12}px;
    height: ${height - 12}px;
  }

  &:hover {
    border-color: ${({ theme }) => theme.primarySelection};

    ${ThumbnailMenu} {
      opacity: 1;
      pointer-events: auto;
    }
  }

  & ${MediaIconContainer} {
    transition: filter 125ms ease-in-out;
    filter: grayscale(0%);
  }

  &:not(.selected) ${MediaIconContainer} {
    filter: grayscale(100%);
  }

  &.selected:not(:hover) {
    border-color: ${({ theme }) => theme.primary};
  }

  transition: border-color 125ms ease-in-out;
`;

// So we're not directly exporting a styled component.
export const Thumbnail = (props: HTMLAttributes<HTMLDivElement>) => {
  return <StyledThumbnail {...props} />;
};
